<template>
    <div id="conversation-widget">
        <div class="custom-content">
            <div class="header">
                <div class="closeBtn" @click="closeChatHistory(false)" />
                <div class="title">
                    <span>Sohbet Geçmişi</span>
                </div>
            </div>
            <div class="body">
                <div v-if="loading" class="spinnerClass">
                    <a-spin></a-spin>
                </div>
                <div v-else>
                    <MessageList
                        v-once
                        :always-scroll-to-bottom="true"
                        :colors="colors"
                        :messages="messages"
                        :participants="participants"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MessageList from "./popup-chat/MessageList";
import { log2 } from "../utils/log2";
import { toNewMessagesModel } from "../utils/chat";
import * as _ from "lodash";

const log = log2("UserChatHistoryWidget");

export default {
    name: "UserChatHistoryWidget",
    components: {
        MessageList,
    },
    props: {
        visitorId: {
            type: String,
            required: true,
        },
        conversationId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            messages: [],
            cancels: [],
            participants: [],
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
        };
    },
    mounted() {
        this.loadChat();
        const handleKeyUp = (event) => {
            console.log("handleKeyUp", event);
            if (event.key === "Escape") {
                event.stopPropagation();
                this.closeChatHistory();
            }
        };
        window.addEventListener("keyup", handleKeyUp);
        this.cancels.push(() => {
            window.removeEventListener("keyup", handleKeyUp);
        });
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    computed: {
        ...mapGetters({
            getUser: "user/getUser",
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapActions({
            loadOldMessages: "chat/loadOldMessages",
        }),
        loadChat() {
            this.loading = true;
            this.loadOldMessages(this.conversationId).then((response) => {
                const { data } = response.data;
                if (Array.isArray(data)) {
                    this.messages = toNewMessagesModel(data, this);
                    this.participants = [];
                }
                this.loading = false;
            });
        },
        getParticipants(conversation) {
            const supportUsers = conversation.messages
                .filter((x) => x.messageType === "user")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));
            return _.uniqBy(supportUsers, (q) => q.name);
        },
        closeChatHistory(event) {
            if (event) {
                event.stopPropagation();
            }
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
#conversation-widget {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 99999999999;
    padding: 30px;
    background-color: #0c131bcc;

    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 200px;
    }

    .custom-content {
        background-color: #f5f5f5;
        border-radius: 8px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        box-shadow: 0 0 10px #000000;

        .header {
            height: 36px;
            box-shadow: 0 0 2px #00000080 inset;
            padding: 0 15px;
            display: flex;
            align-items: center;

            .closeBtn {
                height: 12px;
                width: 12px;
                border-radius: 50%;
                background-color: #ff4d4f;
                box-shadow: 0 0 3px #00000080 inset;
                transition: all 0.3s;
                cursor: pointer;

                &:hover {
                    box-shadow: 0 0 6px #00000080 inset;
                }
            }

            .title {
                font-family: Poppins;
                font-size: 16px;
                font-weight: 400;
                color: #1e1e2d;
                justify-self: center;
                margin: auto;
                padding-right: 12px;
            }
        }

        .body {
            padding: 10px 15px;
            background-color: #fefefe;
            height: 100%;
            overflow-y: scroll;

            .spinnerClass {
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
}
</style>
